import { createPinia, setActivePinia } from "pinia";
import piniaPersist from 'pinia-plugin-persist';
//import { createApp, defineCustomElement, getCurrentInstance, h } from 'vue';


// import router from '@/router';
import TickChatWidget from "./components/molecules/widget/TickChatWidget.ce.vue";
import { defineCustomElement } from "./helpers/defineCustomElementWithStyles";
import useAppStore from "./store/app";

const pinia = createPinia();
pinia.use(piniaPersist);

setActivePinia(pinia);

// const app = createApp(TickChatWidget)
//   .use(pinia);
//.use(router);


//app.mount('#app');

const tickChatWidgetElement = defineCustomElement(TickChatWidget, { plugins: [pinia] });
//const tickChatWidgetElement = defineCustomElement(TickChatWidget);

customElements.define('tick-chatwidget', tickChatWidgetElement);




window.addEventListener('resize', function (event) {
    useAppStore().onWindowResize();
}, true);